import React from "react";
import Common_title from "../../common-components/common_title/Common_title";
import "./Flag_State.css";
import { Col, Container, Row } from "react-bootstrap";

const Flag_State = () => {
  const flagData = [
    {
      img: "assets/images/home/flag_state/bahamas.png",
      title: "Bahamas",
      desc:
        "A trusted international registry demanding reliable medical certification for seafarers on Bahamas-flagged ships.",
    },
    {
      img: "assets/images/home/flag_state/malta.png",
      title: "Malta",
      desc:
        "An EU-based flag state that follows rigorous medical guidelines for seafarer health and vessel safety.",
    },
    {
      img: "assets/images/home/flag_state/marshall.png",
      title: "Marshall Islands",
      desc:
        "A globally recognized flag administration known for high safety & medical compliance standards for international seafarers.",
    },
    {
      img: "assets/images/home/flag_state/panama.png",
      title: "Panama",
      desc:
        "The world’s largest ship registry, requiring standardized medical fitness for seafarers serving on Panama-flagged vessels.",
    },
    {
      img: "assets/images/home/flag_state/cyprus.png",
      title: "Cyprus",
      desc:
        "An established European maritime administration ensuring crew meet approved medical and fitness standards.",
    },
    {
      img: "assets/images/home/flag_state/liberia.png",
      title: "Liberia",
      desc:
        "One of the top open registries that mandates strict medical fitness checks for crew working on Liberia-flagged ships.",
    },
    {
      img: "assets/images/home/flag_state/hong-kong.png",
      title: "Hong Kong",
      desc:
        "A leading Asian registry requiring verified medical clearance for crew serving on Hong Kong-registered vessels.",
    },
    {
      img: "assets/images/home/flag_state/singapore.png",
      title: "Singapore",
      desc:
        "A premium, quality-driven registry requiring medically fit and compliant crew for Singapore-flag vessels.",
    },
    {
      img: "assets/images/home/flag_state/vanuatu.png",
      title: "Vanuatu",
      desc:
        "A globally active open registry that mandates valid medical fitness certification for seafarers on Vanuatu-flagged vessels.",
    },
  ];
  return (
    <section className="flag_state_section">
      <Container>
        <div className="flag_state_title_holder">
          <Common_title text="⚓ FLAG STATE MEDICALS" />
        </div>

        <div className="flag_state_subtitle_holder">
          <p className="flag_state_subtitle">
            At Shore Clinic, we conduct Foreign Flag Vessel / <br /> Flag State
            Medical Examinations recognized by major international maritime
            authorities.
          </p>
        </div>

        <div className="flag_cards_row">
          <Row >
            {flagData.map((item, index) => (
              <Col md={4} sm={6} xs={12} key={index} className="flag_col mb-5">
                <div className="flag_card">
                  <div className="flag_header">
                    <img
                      src={item.img}
                      alt={item.title}
                      className="flag_icon"
                    />
                    <h5 className="flag_title">{item.title}</h5>
                  </div>
                  <p className="flag_desc">{item.desc}</p>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default Flag_State;
